export default __webpack_public_path__ + "static/media/team-2.8e4a073c.jpg";